document.addEventListener("DOMContentLoaded", function () {
  function initializeFlickity() {
    const mobileSlider = document.querySelector(".mobile-slider");
    if (!mobileSlider) return;

    if (window.innerWidth <= 768) {
      if (!mobileSlider.classList.contains("is-flickity-initialized")) {
        var flkty = new Flickity(mobileSlider, {
          cellAlign: "center",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          autoPlay: false,
        });
        mobileSlider.classList.add("is-flickity-initialized");
      }
    } else {
      var flickityInstance = Flickity.data(mobileSlider);
      if (flickityInstance) {
        flickityInstance.destroy();
        mobileSlider.classList.remove("is-flickity-initialized");
      }
    }
  }

  initializeFlickity();

  var variantInputs = document.querySelectorAll('.variant-input input[type="radio"]');
  variantInputs.forEach(function (input) {
    input.addEventListener("change", function (event) {
      event.preventDefault();
      const variantChangeEvent = new CustomEvent('variantChange', {
        detail: { variant: this.value }
      });
      document.dispatchEvent(variantChangeEvent);
      initializeFlickity();
    });
  });

  window.addEventListener("resize", function () {
    initializeFlickity();
  });
});

$(document).on("change", ".variant-selector", function () {
  var selectedVariant = $(this).val();
  var newImageSrc = $('[data-variant-id="' + selectedVariant + '"]').attr("src");
  $(".product-image-main img").attr("src", newImageSrc);
});

document.addEventListener("quickview:open", function (evt) {
  setTimeout(function () {

    var modalId = "QuickShopModal-" + evt.detail.productId;
    var modal = document.getElementById(modalId);
    if (!modal) return;

    // Get selected purity (10K/14K/18K) and color (Yellow/White/Rose)
    function getSelectedValue() {
      var checkedInputs = modal.querySelectorAll('input[type="radio"]:checked');
      var purity = '';
      var color = '';
      checkedInputs.forEach(function (inp) {
        if (inp.dataset.variantPurityInput) {
          purity = inp.dataset.variantPurityInput.replace(/\s+/g, '').toLowerCase();
        }
        if (inp.dataset.variantColorInput) {
          color = inp.dataset.variantColorInput.replace(/\s+/g, '').toLowerCase();
        }
      });
      if (purity && color) {
        return purity + color + 'gold';
      }
      return purity || color || '';
    }

    // Update METAL — 10K label when purity changes
    function updateMetalLabel() {
      var checkedInputs = modal.querySelectorAll('input[type="radio"]:checked');
      checkedInputs.forEach(function (inp) {
        if (inp.dataset.variantPurityInput) {
          var newValue = inp.dataset.variantPurityInput;
          modal.querySelectorAll('[data-variant-purity-label]').forEach(function (span) {
            span.textContent = newValue;
          });
        }
      });
    }

    // Update COLOR — Yellow label when color changes
    function updateColorLabel() {
      var checkedInputs = modal.querySelectorAll('input[type="radio"]:checked');
      checkedInputs.forEach(function (inp) {
        if (inp.dataset.variantColorInput) {
          var newValue = inp.dataset.variantColorInput;
          modal.querySelectorAll('[data-variant-color-label]').forEach(function (span) {
            span.textContent = newValue;
          });
        }
      });
    }

    // Show/hide images based on selected variant
    function filterModalImages() {
      var allMedia = modal.querySelectorAll("[data-media-alt], [thumbnail-alt]");
      if (!allMedia.length) return;

      var selectedValue = getSelectedValue();

      if (!selectedValue) {
        allMedia.forEach(function (el) { showElement(el); });
        return;
      }

      allMedia.forEach(function (el) {
        var altText = el.getAttribute("data-media-alt") || el.getAttribute("thumbnail-alt") || "";
        var alts = altText.split("#").map(function (a) {
          return a.trim().replace(/\s+/g, "").toLowerCase();
        });

        var shouldShow = alts.some(function (alt) {
          return alt && (
            alt === selectedValue ||
            alt.indexOf(selectedValue) > -1 ||
            selectedValue.indexOf(alt) > -1
          );
        });

        if (shouldShow) {
          showElement(el);
        } else {
          hideElement(el);
        }
      });
    }

    function showElement(el) {
      el.style.display = "block";
      el.style.visibility = "visible";
      el.style.opacity = "1";
      el.style.height = "auto";
      el.style.overflow = "visible";
      var img = el.querySelector("img");
      if (img) {
        img.style.display = "block";
        img.style.visibility = "visible";
        img.style.opacity = "1";
      }
      var imageEl = el.querySelector("image-element");
      if (imageEl) {
        imageEl.style.display = "block";
        imageEl.style.opacity = "1";
      }
    }

    function hideElement(el) {
      el.style.display = "none";
      el.style.visibility = "hidden";
      el.style.opacity = "0";
      el.style.height = "0";
      el.style.overflow = "hidden";
      var img = el.querySelector("img");
      if (img) {
        img.style.display = "none";
        img.style.visibility = "hidden";
        img.style.opacity = "0";
      }
      var imageEl = el.querySelector("image-element");
      if (imageEl) {
        imageEl.style.display = "none";
        imageEl.style.opacity = "0";
      }
    }

    // Fix all inputs inside modal so they are clickable
    function fixModalInputs() {
      modal.querySelectorAll('.variant-input-wrap, .variant-input').forEach(function (wrap) {
        wrap.style.pointerEvents = "auto";
        wrap.style.zIndex = "999";
        wrap.style.position = "relative";
      });
      modal.querySelectorAll('input[type="radio"], label, select').forEach(function (el) {
        el.style.pointerEvents = "auto";
        el.style.cursor = "pointer";
      });
      modal.querySelectorAll('select').forEach(function (sel) {
        sel.style.pointerEvents = "auto";
        sel.style.zIndex = "999";
        sel.style.position = "relative";
        sel.style.display = "block";
        sel.style.width = "100%";
      });
    }

    // Run everything on modal open
    filterModalImages();
    updateMetalLabel();
    updateColorLabel();
    fixModalInputs();

    // Re-run when any radio button changes
    modal.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener("change", function () {
        setTimeout(function () {
          filterModalImages();
          updateMetalLabel();
          updateColorLabel();
        }, 150);
      });
    });

    modal.addEventListener("variantChange", function () {
      setTimeout(function () {
        filterModalImages();
        updateMetalLabel();
        updateColorLabel();
      }, 150);
    });

  }, 500);
});
document.addEventListener("quickview:loaded", function () {
  setTimeout(function () {
    var modal = document.querySelector('[id^="QuickShopModal"]');
    if (!modal) return;

    var searchInput = modal.querySelector('#dropdownSearch-modal, #dropdownSearch');
    var dropdown = modal.querySelector('#dropdown-modal, #dropdown');
    var selectedOption = modal.querySelector('#selectedOption-modal, #selectedOption');
    var selectDataSpan = modal.querySelector('#selectdata2-modal, #selectdata2');

    if (!searchInput || !dropdown) return;

    // Open dropdown on focus/click
    searchInput.addEventListener('focus', function () {
      dropdown.style.display = 'block';
    });

    searchInput.addEventListener('click', function () {
      dropdown.style.display = 'block';
    });

    // Filter items on keyup
    searchInput.addEventListener('keyup', function () {
      var filter = searchInput.value.toLowerCase();
      var items = dropdown.getElementsByClassName('dropdown-item');
      for (var i = 0; i < items.length; i++) {
        var text = items[i].textContent || items[i].innerText;
        items[i].style.display = text.toLowerCase().indexOf(filter) > -1 ? '' : 'none';
      }
    });

    // Select item on click
    dropdown.addEventListener('click', function (event) {
      if (event.target.classList.contains('dropdown-item')) {
        var selectedValue = event.target.getAttribute('data-value');
        searchInput.value = selectedValue;
        if (selectedOption) selectedOption.value = selectedValue;
        if (selectDataSpan) selectDataSpan.textContent = selectedValue;
        dropdown.style.display = 'none';
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function (event) {
      if (searchInput && dropdown) {
        if (!searchInput.contains(event.target) && !dropdown.contains(event.target)) {
          dropdown.style.display = 'none';
        }
      }
    });

    // Make sure dropdown is visible above modal
    dropdown.style.position = 'absolute';
    dropdown.style.zIndex = '9999';
    dropdown.style.background = 'white';
    dropdown.style.width = searchInput.offsetWidth + 'px';

  }, 800);
});
// Enable Quick View on mobile
document.addEventListener("page:loaded", function () {
  var products = document.querySelectorAll(".grid-product");
  if (!products.length || !theme.settings.quickView) return;

  products.forEach(function (product) {
    var btn = product.querySelector(".quick-product__btn");
    if (btn) {
      btn.classList.remove("quick-product__btn--not-ready");
      btn.style.display = "block";
      btn.style.opacity = "1";
      btn.style.visibility = "visible";
    }
  });
});
// Force Quick View modal on mobile
document.addEventListener("page:loaded", function () {
  if (!theme.settings.quickView) return;

  function initMobileQuickShop() {
    document.querySelectorAll(".grid-product").forEach(function (product) {
      if (product.dataset.mobileQuickInit) return;
      product.dataset.mobileQuickInit = "true";

      product.addEventListener("click", function (evt) {
        var btn = evt.target.closest(".quick-product__btn");
        if (!btn) return;

        evt.preventDefault();
        evt.stopPropagation();

        var productId = product.dataset.productId;
        var handle = product.dataset.productHandle;

        if (!productId || !handle) return;

        theme.preloadProductModal(handle, productId, btn);

        var attempts = 0;
        var interval = setInterval(function () {
          attempts++;
          var modalId = "QuickShopModal-" + productId;
          var modal = document.getElementById(modalId);
          if (modal) {
            clearInterval(interval);
            var modalInstance = new theme.Modals(
              modalId,
              "quick-modal-" + productId
            );
            modalInstance.open();
          }
          if (attempts > 20) clearInterval(interval);
        }, 200);
      });
    });
  }

  initMobileQuickShop();
  document.addEventListener("collection:reloaded", initMobileQuickShop);
});